import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import agentImage from 'Design-system/app/static/images/support-widget/agent.png';

import './SupportHelpBanner.scss';

export interface SupportHelpBannerProps {
  onRequestHelp(): void;
}

/**
 * The tinted help block at the bottom of the exit-intent panel (#5622).
 *
 * Rendered only within working hours — the caller decides from the resolved
 * support `state`. When support is closed, this block is absent entirely: not
 * greyed out, no hour line, no contact-form fallback.
 */
export const SupportHelpBanner = ({ onRequestHelp }: SupportHelpBannerProps) => {
  const { t } = useTranslation();

  return (
    <aside styleName="support-help-banner">
      <span styleName="support-help-banner__avatar">
        <span className="support-widget__avatar-photo">
          <img src={agentImage} width="52" height="52" alt="" decoding="async" loading="lazy" />
        </span>
      </span>

      <div styleName="support-help-banner__body">
        <p styleName="support-help-banner__text">
          <Trans i18nKey="T.POST-JOB.EXIT-INTENT.BANNER-TEXT"
                 defaults="<lead>Stuck on something?</lead> Tell us how we can help."
                 components={{ lead: <span styleName="support-help-banner__lead" /> }}
          />
        </p>

        <button type="button" styleName="support-help-banner__cta" onClick={onRequestHelp}>
          <span styleName="support-help-banner__cta-icon" className="dashicon dashicon-circle-arrow-right-light" />
          {t('T.POST-JOB.EXIT-INTENT.BANNER-CTA', 'I want help')}
        </button>
      </div>
    </aside>
  );
};

export default SupportHelpBanner;
